import mainDelegate from '@/delegate/mainDelegate'
export default {
    mixins: [mainDelegate],
    watch: {
        isLogin(val) {
            if (val) {
                this.$router.replace({ name: 'main' })
            } else {
                this.$router.replace({ name: 'login' })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/loginController.js